var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"svg-icon flex-shrink-0 flex-grow-0",style:(_vm.style),attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":_vm.href}})])}
var staticRenderFns = []

export { render, staticRenderFns }